import * as React from 'react';
import InformationTable from 'components/common/table/InformationTable';
import { InformationObject } from 'types/common/informationTable';
import { GetInvoiceDetailBackOrderInfo } from 'types/plansales/invoice/invoiceDetail';
import { getUSFormatDate } from 'modules/utils/time';
import { NULL_TEXT } from 'constants/common';

interface Props {
  data: GetInvoiceDetailBackOrderInfo;
}

const InvoiceDetailBackOrderInformation = ({ data }: Props) => {
  const currency = '$ '; // TODO: ted 께서 주시는 api 에서 통화단위를 받아온다.
  const backOrderData: InformationObject[] = [
    {
      title: 'Order Date',
      render: data ? getUSFormatDate(data.registeredAt) : NULL_TEXT,
      titleWidth: '30%',
    },
    {
      title: 'Subscription Term',
      render: data?.subscriptionTerm
        ? `${getUSFormatDate(data.subscriptionTerm.startDate)} - ${getUSFormatDate(
            data.subscriptionTerm.endDate,
          )} `
        : NULL_TEXT,
      titleWidth: '30%',
    },
    {
      title: 'Current Credit Balance',
      render: data ? currency + data.currentCredit.toFixed(2) : NULL_TEXT,
      titleWidth: '30%',
    },
  ];

  return <InformationTable title={'Back Order'} data={backOrderData} />;
};

export default InvoiceDetailBackOrderInformation;
